import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import * as actions from './Actions.js';

export class NotasExplicativas extends Component {
  static propTypes = {
    pathname: PropTypes.string.isRequired,
    notasFiltradas: PropTypes.object,
    findNotaExplicativaByMenu: PropTypes.func
  };

  componentDidMount() {
    const { findNotaExplicativaByMenu, pathname } = this.props;
    let newPathname = pathname;

    findNotaExplicativaByMenu(newPathname);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { findNotaExplicativaByMenu, pathname } = this.props;

    if (pathname !== nextProps.pathname) {
      findNotaExplicativaByMenu(nextProps.pathname);
    }
  }

  renderNotas = nota => {
    return (
      <li key={nota.get('id')} style={{ marginTop: '5px' }}>
        {nota.get('notaExplicativa')}
      </li>
    );
  };

  render() {
    const { notasFiltradas } = this.props;

    const notasFiltradasEspecificas = notasFiltradas.filter(
      n => n.get('path') === this.props.pathname
    );

    if (!notasFiltradasEspecificas || notasFiltradasEspecificas.isEmpty()) {
      return null;
    }

    return (
      <Row>
        <Col sm={12} className="mb-xs">
          <div className="info primary icon">
            <div className="icon">
              <em className="fa fa-info-circle"></em>
            </div>

            <article>
              <h4>{notasFiltradasEspecificas.map(this.renderNotas)}</h4>
            </article>
          </div>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    notasFiltradas: state.notaExplicativa.get('notasFiltradas')
  };
}

export default connect(mapStateToProps, actions)(NotasExplicativas);
